import PropTypes from 'prop-types';
import React from 'react';
import { minimalPieChartDataProps } from '../../Includes/chartProps';
import MinimalCircularChart from '../MinimalCircularChart/MinimalCircularChart';

import './PieChartPageSection.scss';

export default class PieChartPageSection extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * Title For Page Section Header
         */
        sectionTitle: PropTypes.node,
        /**
         * data for the charts
         * make sure the values go in the order of yes, no, maybe
         */
        chartProps: minimalPieChartDataProps,
        /**
         * Info for button
         */
        sectionButton: PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
        }),
    };

    static defaultProps = {};

    render() {
        let sectionButton = null;
        if (this.props.sectionButton) {
            sectionButton = (
                <ButtonForPageSection
                    text={this.props.sectionButton.text}
                    url={this.props.sectionButton.url}
                />
            );
        }
        const header = (
            <div className="section-header">{this.props.sectionTitle}</div>
        );
        return (
            <div className="component-Charts-PieChartPageSection">
                {header}
                <div className="d-flex flex-column chartSection">
                    {this.props.chartProps.map((chart, idx) => {
                        return (
                            <div
                                key={idx}
                                className={`d-flex justify-content-center align-items-center chart`}
                            >
                                <MinimalCircularChart {...chart} />
                            </div>
                        );
                    })}
                </div>
                {sectionButton}
            </div>
        );
    }
}
